<form [formGroup]="form">
  <div class="form-group">
    <label class="bmd-label-floating" for="validDocumentTypes">File Type</label>
    <input
      type="text"
      class="form-control"
      formControlName="validDocumentTypes"
      name="validDocumentTypes"
      aria-describedby="validDocumentTypesHelp"
      [(ngModel)]="documentDE.validDocumentTypes"
    />
    <small id="validDocumentTypesHelp" class="form-text text-muted">
      File Types (seperate multiple files using ",")
    </small>
    <wm-control-message
      [control]="form.controls['validDocumentTypes']"
    ></wm-control-message>
  </div>
  <div class="form-group">
    <div class="switch">
      <label>
        <input
          type="checkbox"
          class="float-right"
          formControlName="requireReview"
          [(ngModel)]="documentDE.requireReview"
        />
        Require Review
      </label>
    </div>
    <small class="form-text text-muted">
      When enabled, uploaded documents will require review before being accepted.
    </small>
  </div>
</form>
